import Dashboard from "@pathwright/web/src/modules/home/Dashboard"
import { getHomeActivePath } from "@pathwright/web/src/modules/home/useHomeActiveEntries"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import { canViewUnifiedHome } from "@pathwright/web/src/modules/unified-home/useCanViewUnifiedHome"
import { canGoHome } from "belltower/utils"
import { useAsync } from "react-use"
import StoreOrLibraryBrowse from "store/StoreOrLibraryBrowse"
import Homescreen from "../../unified-home/Homescreen"

// Checks for both the feature permission and the home active path
// allowing user to access the unfied home if either condition is met.
function useUnifiedHome({ params }) {
  const pwContext = usePathwrightContext()
  const hasFeaturePerm = useAsync(canViewUnifiedHome, [])
  const homeActivePath = getHomeActivePath(pwContext)
  const hasUnifiedHome =
    hasFeaturePerm.value ||
    // Allow access to unified home if the user is has previously accessed it
    // and the current section is not specified or is "unified".
    (homeActivePath?.startsWith("/home/unified") &&
      (!params.section || params.section === "unified"))

  return {
    loading: hasFeaturePerm.loading,
    value: hasUnifiedHome
  }
}

const HomeOrLibraryBrowse = (props) => {
  const { loading, value: hasUnifiedHome } = useUnifiedHome(props)

  if (loading) {
    return null // or a loading spinner
  }

  return canGoHome() ? (
    hasUnifiedHome ? (
      <Homescreen key="Home" />
    ) : (
      <Dashboard {...props} />
    )
  ) : (
    <StoreOrLibraryBrowse {...props} schoolId={window.school.id} />
  )
}

HomeOrLibraryBrowse.displayName = "HomeOrLibraryBrowse"

export default HomeOrLibraryBrowse
